export default class Header {
  constructor() {
    this._header = document.querySelector(".jsHeader");
    this._headerNav = document.querySelector(".jsHeaderTopNav");

    // helpers
    this._scrollY = window.scrollY;

    if (this._header && !document.querySelector(".jsProgressBar")) this.init();
  }

  pinHeader() {
    // determine scroll
    if (this._scrollY > window.scrollY) {
      this._header.classList.add("pinned");
      this._headerNav.classList.add("pinned");
    } else {
      this._header.classList.remove("pinned");
      this._headerNav.classList.remove("pinned");
    }

    this._scrollY = window.scrollY;
  }

  handleScroll(isInArea) {
    if (isInArea) {
      this.pinHeader()
    } else {
      this._header.classList.remove("pinned");
      this._headerNav.classList.remove("pinned");
    }
  }

  init() {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 450) {
        this.handleScroll(true);
      } else {
        this.handleScroll(false);
      }
    });
  }
}
